import { FilterOptionFields } from "./Fields";

const SIX_MONTHS_IN_DAYS = 180;
const ONE_YEAR_IN_DAYS = 365;
const TWO_YEARS_IN_DAYS = 730;
const UNIX_EPOCH_DATE = "1970-01-01T00:00:00Z"

export const customDateFilter = (value: any, filter: any, optionalInitialDate: Date) => {

    if (filter === null || !filter.length) return true;

    if (value === null || value === undefined) {
        return false;
    }

    let dateForComparison = value.dateTo ? value.dateTo : value.dateFrom;

    try {
        dateForComparison = new Date(dateForComparison);
    } catch (err) {
        return false;
    }

    let match = false;

    filter.forEach((x : any) => {
        let mostRecentDate;
        let oldestDate;

        if (!optionalInitialDate) {
            mostRecentDate = new Date();
            oldestDate = new Date();
        } else {
            mostRecentDate = new Date(optionalInitialDate);
            oldestDate = new Date(optionalInitialDate);
        }


        switch (x) {
            case FilterOptionFields.UNDER_SIX_MONTHS:
                oldestDate.setDate(oldestDate.getDate() - SIX_MONTHS_IN_DAYS);
                break;
            case FilterOptionFields.BETWEEN_SIX_MONTHS_AND_ONE_YEAR:
                mostRecentDate.setDate(mostRecentDate.getDate() - SIX_MONTHS_IN_DAYS);
                oldestDate.setDate(oldestDate.getDate() - ONE_YEAR_IN_DAYS);
                break;
            case FilterOptionFields.BETWEEN_ONE_YEAR_AND_TWO_YEARS:
                mostRecentDate.setDate(mostRecentDate.getDate() - ONE_YEAR_IN_DAYS);
                oldestDate.setDate(oldestDate.getDate() - TWO_YEARS_IN_DAYS);
                break;
            case FilterOptionFields.OVER_TWO_YEARS:
                mostRecentDate.setDate(mostRecentDate.getDate() - TWO_YEARS_IN_DAYS);
                oldestDate = new Date(UNIX_EPOCH_DATE);
                break;
        }

        if (dateForComparison <= mostRecentDate && dateForComparison >= oldestDate) {
            match = true;
        }
    });

    return match;
}

export const customQuotationDateFilter = (value: any, filter: any, optionalInitialDate: Date) => {
        if (filter === null || !filter.length) return true;
        if (value === null || value === undefined) {
            return false;
        }
    
        let dateForComparison = value.dateTo ? value.dateTo : value.dateFrom;
    
        try {
            dateForComparison = new Date(dateForComparison);
        } catch (err) {
            return false;
        }
    
        let match = false;
    
        filter.forEach((filterValue: string) => {
            let mostRecentDate;
            let oldestDate;
    
            if (!optionalInitialDate) {
                mostRecentDate = new Date();
                oldestDate = new Date();
            } else {
                mostRecentDate = new Date(optionalInitialDate);
                oldestDate = new Date(optionalInitialDate);
            }
    
            switch (filterValue) {
                case FilterOptionFields.UNDER_TWO_WEEKS:
                    oldestDate.setDate(oldestDate.getDate() + 14);
                    break;
                case FilterOptionFields.BETWEEN_TWO_WEEKS_AND_ONE_MONTH:
                    mostRecentDate.setDate(mostRecentDate.getDate() + 14);
                    oldestDate.setDate(oldestDate.getDate() + 30);
                    break;
                case FilterOptionFields.BETWEEN_ONE_MONTH_AND_TWO_MONTHS:
                    mostRecentDate.setDate(mostRecentDate.getDate() + 30);
                    oldestDate.setDate(oldestDate.getDate() + 60);
                    break;
                case FilterOptionFields.OVER_TWO_MONTHS:
                    mostRecentDate.setDate(mostRecentDate.getDate() + 60);
                    oldestDate = undefined;
                    break;
            }

            if (oldestDate) {
                if (dateForComparison >= mostRecentDate && dateForComparison <= oldestDate) {
                    match = true;
                }
            } else {
                if (dateForComparison >= mostRecentDate) {
                    match = true;
                }
            }
        });
    
        return match;
};
